module.exports = __webpack_public_path__ + "img/trash_can.d1566429.svg";